/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */

export default class Metrika {
  async handleEvent(key, value) {
    this.push({
      key,
      value: {
        ...value,
        source: 'HOME_HANDS_RU',
      },
    });
  }

  push({key, value}) {
    if (window?.yaCounter93362321) {
      window.yaCounter93362321.reachGoal(key, value);
    }
  }
}
